// HOME ADD STICKY HEADER AFTER SECTION
// var headertopheight = $(".header-top").height();
// var headerbottomheight = $(".header-bottom").height();
// var totalheaderheight = headertopheight + headerbottomheight;

$(window).on('scroll', function() {
  // No aplicar lógica de header sticky/hover en páginas DESDEMONA
  if ($('body').hasClass('desdemona')) return;

  var scroll = $(window).scrollTop();

  if (scroll >= 15) {
    $(".template-index .shopify-section--header").css('position','fixed');
    $(".template-index .header-block .Header").css({"visibility": "visible", "height": "100%", "transform": "translateY(0)"});
    $(".header-block.other-page-header").addClass("add-sticky");
  } else {
    $(".template-index .shopify-section--header").css('position','fixed');
    $(".template-index .header-block .Header").css({"visibility": "visible", "height": "100%", "transform": "translateY(-100%)"});
    $(".header-block.other-page-header").removeClass("add-sticky");
  }
});



$( document ).ready(function() {
  
$(document).ready(function () {
  // --- HOVER del header (sin tocar el banner) ---
  var $hoverTargets = $(".header-top-wrapper, .template-index .shopify-section--header");

  // En páginas DESDEMONA anulamos cualquier hover que afecte al header
  if ($('body').hasClass('desdemona')) {
    $hoverTargets.off('mouseenter mouseleave');
    $(".header-bottom-banner").off('mouseenter mouseleave'); // por si había handlers previos
  } else {
    // Rebind limpio (por si venías de recargas parciales)
    $hoverTargets.off('mouseenter mouseleave').hover(
      function () {
        $(".shopify-section--header").css('position','fixed');
        $(".template-index .shopify-section--header").css('position','fixed');
        $(".template-index .header-block .Header").css({"visibility": "visible", "height": "100%", "transform": "translateY(0)"});
      },
      function () {
        $(".shopify-section--header").css('position','sticky');
        $(".template-index .shopify-section--header").css('position','fixed');
        $(".template-index .header-block .Header").css({"visibility": "hidden", "height": "0", "transform": "translateY(-100%)"});
      }
    );
  }
});
  
['.loop-scroll','.horizontal-logo','.horizontal-logo1','.horizontal-logo2'].forEach(sel=>{
  var $el = $(sel);
  if ($el.length && !$el.hasClass('slick-initialized')) {
    // tu .slick({...}) de cada uno, igual que ahora
  }
});

  // HOME HEADER TOP LOGO SCROLL
  $('.loop-scroll').slick({
    // ... (contenido original de tu init si estaba aquí; se sobreescribe luego por el módulo de normalización)
  });

  // (resto de tu archivo original; funciones, eventos, etc.)
  // ————————————————————————————————————————————————————————————————
  // (Se omiten comentarios repetidos largos por brevedad; se mantiene tu lógica)
  // ————————————————————————————————————————————————————————————————

var $m = $('.custom-text-scroll');
if ($m.length && !$m.hasClass('slick-initialized')) {
  $m.on('init.marquee', function () { $(this).css('visibility','visible'); });
  $m.slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 10000,
    cssEase: 'linear',
    variableWidth: true,
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
  });
}



//MOBILE TOGGLE JS

  var timesClicked = 0;

  $(".Header__Icon").click(function() {
    // … (tu lógica original)
  });

  // … (más código original)

  // PRODUCT PAGE ACCORDIAN

$(function () {
  // Evita dobles bindings si Shopify reinyecta secciones
  $('.acc__title').off('click.acc').on('click.acc', function (j) {
    j.preventDefault();
    j.stopPropagation(); // <- CLAVE en Desdemona: evita que el listener global lo cierre al instante

    var $title   = $(this);
    var $acc     = $title.closest('.acc');
    var dropDown = $acc.find('.acc__panel');

    $acc.find('.acc__panel').not(dropDown).slideUp();

    if ($title.hasClass('active')) {
      $title.removeClass('active');
    } else {
      $acc.find('.acc__title.active').removeClass('active');
      $title.addClass('active');
    }

    dropDown.stop(false, true).slideToggle();
  });
});

// … (más código original: listeners Search, Relatin, etc.)

$("input[type=search]").on("change",function (event) {
  if($(this).val() == ""){
    $(this).parents(".Search__SearchBar").removeClass("searching");
  }
});

// === RELATIN · REVEAL-ON-SCROLL ===
window.initRelatinReveal = function(context){
  var scope = context || document;
  var roots = scope.querySelectorAll('.relatin-copy-grid');
  if(!roots.length) return;

  roots.forEach(function(root){
    var els = root.querySelectorAll('[data-reveal]');
    // … (tu lógica original)
  });
};

// (el resto de utilidades originales siguen igual)

}); // cierre document.ready anidado si existía
// ————————————————————————————————————————————————————————————————
// ————————————————————————————————————————————————————————————————



document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.vinyl-swatch');
  if (!swatch) return;

  const mediaId = swatch.dataset.mediaId;

  // marcar activo
  document.querySelectorAll('.vinyl-swatch').forEach(el => {
    el.classList.remove('is-active');
  });
  swatch.classList.add('is-active');

  // cambiar solo el slide del carrusel (Flickity), sin abrir fullscreen
  const slideshow = document.querySelector('.Product__Slideshow');
  if (!slideshow || typeof Flickity === 'undefined') return;

  const flkty = Flickity.data(slideshow);
  if (!flkty) return;

  const cells = slideshow.querySelectorAll('[data-media-id]');
  let index = -1;

  cells.forEach(function (cell, i) {
    if (cell.getAttribute('data-media-id') === mediaId && index === -1) {
      index = i;
    }
  });

  if (index >= 0) {
    flkty.select(index, false, true);
  }
});



/* === Normalizar velocidad visual de banners (desktop y móvil) === */
(function() {
  var PX_PER_SECOND = 30; // ajustar velocidad

  function computeSpeedMs($el){
    try {
      var w = 0;
      // Si ya está slick, intentamos coger el ancho visible del carrusel
      if ($el && $el.length) {
        var $list = $el.find('.slick-list');
        if ($list.length) { w = $list.outerWidth(true); }
        if (!w) { w = $el.outerWidth(true); }
      }
      if (!w || isNaN(w)) { w = $(window).width() || 375; }
      var ms = Math.max(1000, Math.round((w / PX_PER_SECOND) * 1000));
      return ms;
    } catch(e){
      return 10000; // fallback estable
    }
  }

  function initMarquee($el, baseOptions){
    if (!$el || !$el.length) return;

    // Si ya estaba, destruir para recalcular velocidad
    if ($el.hasClass('slick-initialized')) {
      try { $el.slick('unslick'); } catch(e){}
    }

    var speedMs = computeSpeedMs($el);
    var opts = $.extend(true, {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,   // para efecto continuo
      speed: speedMs,     // normalizado por ancho
      cssEase: 'linear',
      arrows: false,
      pauseOnHover: false,
      variableWidth: true,
      infinite: true,
      dots: false
    }, baseOptions || {});

    // Visibilidad limpia tras init para evitar parpadeo
    $el.css('visibility','hidden').on('init._marquee', function(){ $(this).css('visibility','visible'); });
    $el.slick(opts);
  }

  function reinitAll(){
    // Header bottom banner (ajusta la clase si tu banner usa otra)
    initMarquee($('.loop-scroll'), {
      variableWidth: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });

    // Banner de texto alternativo
    initMarquee($('.custom-text-scroll'), {
      slidesToShow: 2,
      slidesToScroll: 2
    });

    // Filas de logos
    initMarquee($('.horizontal-logo'), {
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [{ breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 1 } }]
    });
    initMarquee($('.horizontal-logo1'), {
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [{ breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 1 } }]
    });
    initMarquee($('.horizontal-logo2'), {
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [{ breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 1 } }]
    });
  }

  // Inicia una vez que el DOM está listo (y después de otras inits)
  $(function(){
    // Reinit diferido para asegurar que las inits originales ya corrieron
    setTimeout(reinitAll, 0);

    var t;
    $(window).on('resize orientationchange', function(){
      clearTimeout(t);
      t = setTimeout(reinitAll, 150);
    });
  });
})();



document.addEventListener('DOMContentLoaded', function () {
  // spans de título con info de variante
  var titles  = document.querySelectorAll('.v-title[data-variant-id]');
  var swatches = document.querySelectorAll('.vinyl-swatch');

  if (!titles.length || !swatches.length) return;

  var isHoverDevice = window.matchMedia &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Construimos una lista de filas <li> que contienen cada v-title
  var rows = [];

  titles.forEach(function (title) {
    var row = title.closest('li');
    if (!row) return;

    // Propagamos los datos de variante al <li>
    var variantId = title.getAttribute('data-variant-id');
    var mediaId   = title.getAttribute('data-media-id');

    if (variantId) row.dataset.variantId = variantId;
    if (mediaId)   row.dataset.mediaId   = mediaId;

    // Evitar duplicar la misma fila
    if (rows.indexOf(row) === -1) {
      rows.push(row);
    }
  });

  if (!rows.length) return;

  function triggerMatchingSwatch(row) {
    var variantId = row.dataset.variantId;
    var mediaId   = row.dataset.mediaId;

    var swatch = null;

    // 1) Intentamos encontrar el swatch por variant-id
    if (variantId) {
      swatch = document.querySelector('.vinyl-swatch[data-variant-id="' + variantId + '"]');
    }

    // 2) Si no, por media-id
    if (!swatch && mediaId) {
      swatch = document.querySelector('.vinyl-swatch[data-media-id="' + mediaId + '"]');
    }

    if (swatch) {
      swatch.click();  // 👉 reutiliza EXACTAMENTE la lógica original del tema
    }
  }

  rows.forEach(function (row) {
    // Desktop → hover sobre toda la fila
    if (isHoverDevice) {
      row.addEventListener('mouseenter', function () {
        triggerMatchingSwatch(row);
      });
    }

    // Móvil + fallback → click en toda la fila
    row.addEventListener('click', function (e) {
      e.preventDefault();
      triggerMatchingSwatch(row);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {

  // 1. El contador donde se mostrará "2 / 4"
  var counterEl = document.querySelector('.ProductSlideCounter');
  if (!counterEl) return;

  // 2. El carrusel principal Maestrooo
  var carouselEl = document.querySelector('.Product__Slideshow.Carousel');
  if (!carouselEl) return;

  // 3. Obtenemos instancia Flickity correctamente
  var flkty = Flickity.data(carouselEl);
  if (!flkty) {
    // Si Flickity aún no cargó, esperamos
    document.addEventListener('lazyloaded', function () {
      var flktyRetry = Flickity.data(carouselEl);
      if (flktyRetry) initCounter(flktyRetry);
    });
    return;
  }

  initCounter(flkty);

  // Función que sincroniza el contador con Flickity
  function initCounter(flkty) {

    function updateCounter() {
      var current = flkty.selectedIndex + 1;
      var total = flkty.slides.length;
      counterEl.innerHTML = current + ' <span class="h6">/</span> ' + total;
    }

    // Al cargar
    updateCounter();

    // Cada vez que Flickity cambie de slide
    flkty.on('select', updateCounter);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  var share = document.querySelector('.p-share-link');
  if (!share) return;

  // el primer <a> dentro de .p-share-link es tu "SHARE ⮑"
  var toggle = share.querySelector('a[href="javascript:void(0)"]');
  var menu   = share.querySelector('.ProductMeta__ShareList');

  if (!toggle || !menu) return;

  function openShare() {
    share.classList.add('is-open');
  }

  function closeShare() {
    share.classList.remove('is-open');
  }

  function toggleShare() {
    if (share.classList.contains('is-open')) {
      closeShare();
    } else {
      openShare();
    }
  }

  var isHoverDevice = window.matchMedia &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (isHoverDevice) {
    share.addEventListener('mouseenter', openShare);
    share.addEventListener('mouseleave', closeShare);
  }

  toggle.addEventListener('click', function (e) {
    e.preventDefault();
    toggleShare();
  });

  document.addEventListener('click', function (e) {
    if (!share.contains(e.target)) {
      closeShare();
    }
  });
});




